import {DatabaseCode, toDatabaseCode} from "./database-code";

export type ObjectMappingKind = DatabaseCode;

const identifier: ObjectMappingKind = {
  code: "IDENTIFIER",
  displayValue: {
    id: "common.entity.objectmappingkind.identifier",
    defaultMessage: "Identifier",
  },
};

const name: ObjectMappingKind = {
  code: "NAME",
  displayValue: {
    id: "common.entity.objectmappingkind.name",
    defaultMessage: "Name",
  },
};

const alias: ObjectMappingKind = {
  code: "ALIAS",
  displayValue: {
    id: "common.entity.objectmappingkind.alias",
    defaultMessage: "Alias",
  },
};

const search: ObjectMappingKind = {
  code: "SEARCH",
  displayValue: {
    id: "common.entity.objectmappingkind.search",
    defaultMessage: "Search",
  },
};

const meta: ObjectMappingKind = {
  code: "META",
  displayValue: {
    id: "common.entity.objectmappingkind.meta",
    defaultMessage: "Meta",
  },
};

export const objectMappingKind = {
  identifier,
  name,
  alias,
  search,
  meta,
};

export const objectMappingKinds = Object.values(objectMappingKind);

export const toObjectMappingKind = (
  code: string
): ObjectMappingKind =>
  toDatabaseCode(code, objectMappingKinds);

export const toObjectMappingKindSafely = (
  code: string | undefined
): ObjectMappingKind | undefined =>
  code ? toDatabaseCode(code, objectMappingKinds) : undefined;
